import {
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";

import { BayLevelEnum } from "open-vessel-definition";
import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { topContainersOfStack } from "./topContainersOfStack";

export function getContainersByHighestBelow(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const containers: TIContainerInformationExtendedValid[] = [];

  // Only process below deck containers
  if (smartBay.level !== BayLevelEnum.BELOW) {
    return {
      containers,
      tBaysStr: smartBay.tBaysStr,
      level: smartBay.level,
    };
  }

  const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();

  // For each stack, get the highest container below deck
  for (const stackKey of allStacksKeys) {
    containers.push(
      ...topContainersOfStack(smartBay, gridContent, stackKey, allTiersKeys, "highest"),
    );
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
